import React from 'react';
export const WikiRecommendationContext = React.createContext({
    recommendations: [],
});
export const WikiRecommendationsProvider = WikiRecommendationContext.Provider;
export const useWikiRecommendationsContext = () => React.useContext(WikiRecommendationContext);
